import React from "react";
import { FileBarChart } from 'lucide-react';
import { NavItem } from "../NavItem";

export function ReportsLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/reports"
            Icon={FileBarChart}
            label="Reports"
            isCollapsed={isCollapsed}
        />
    );
}
